import PropTypes from 'prop-types';
import React, { useState, useEffect, useCallback, useMemo } from 'react';

import { InputGroup, InputGroupText, Row, Col, Label, FormGroup, Card, CardHeader, CardContent, CardTitle, Separator, SimpleAlert } from 'twyne-new.ui'

import Rules from "@Components/Rules";
import Input from '@Components/formsy/Input';
import InputDecimal from 'components/form/InputDecimal';
import { PureSwitch } from 'components/form/Switch';

const propTypes = {
  title: PropTypes.string,
  fieldName: PropTypes.string,
  fieldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  children: PropTypes.node,
}

export default function Duplicated({ title, fieldName, fieldValue, onChange, children }) {
  const [active, setActive] = useState(false)

  useEffect(() => {
    const newActive = !!fieldValue
    setActive(active => active !== newActive ? newActive : active)
  }, [fieldValue])

  const handleToggle = event => {
    const value = event.target.checked
    if (!value) onChange(null)
    setActive(value)
  }

  return <Card>
    <CardHeader>
      <CardTitle>{title}</CardTitle>
      <PureSwitch value={active} onChange={handleToggle} />
    </CardHeader>

    <CardContent>
      <Separator className='my-2' />
      <Row>
        <Col size="12">
          <Form fieldName={fieldName} fieldValue={fieldValue} onChange={onChange} active={active} />
        </Col>
        <Col size="12">
          {children}
        </Col>
      </Row>
    </CardContent>
  </Card>
}

function Form({ active, fieldName, fieldValue, onChange }) {
  const handleAllowed = useCallback(({ floatValue }) => !floatValue || floatValue <= 365, [])

  if (!active) {
    return null
  }

  if (fieldName === 'duplicate_click_days') {
    return <FormGroup>
      <Label>Override duplicate days</Label>
      <InputDecimal required name='duplicate_click_days' value={fieldValue || 1} onChange={onChange} isAllowed={handleAllowed}
        decimalScale={8} fixedDecimalScale={false} allowNegative={false} thousandSeparator="" decimalSeparator="." prefix="" />
    </FormGroup>
  }

  return <LeadRules data={fieldValue} onChange={onChange} disabled={false} />
}

function LeadRules({ data, onChange, disabled }) {
  const options = useMemo(() => [
    { label: 'Email', value: 'email', type: 'integer', group: 'Default', equalities, Component },
    { label: 'Phone', value: 'phone', type: 'integer', group: 'Default', equalities, Component },
  ], [])

  const conditions = useMemo(() => ({
    groups: [
      { label: 'Any', value: 'or' },
      { label: 'All', value: 'and' },
    ],
    rules: [
      { label: 'All', value: 'and' },
      { label: 'Any', value: 'or' },
    ],
  }), [])

  return <Rules data={data || { condition: 'or', groups: [] }} options={options} conditions={conditions} onChange={onChange} disabled={disabled}>
    {!data?.groups?.length ? <SimpleAlert className="my-2" variant="warning">At least one rule must be defined for duplicate leads settings</SimpleAlert> : null}
  </Rules>
}

const equalities = [{ label: 'Exists within the last', value: 'exists-within-the-last' }]

function Component(props) {
  return <InputGroup>
    <Input {...props} />
    <InputGroupText addonType="append">
      days
    </InputGroupText>
  </InputGroup>
}

export const DEFAULT_DUPLICATE_LEAD = 'email'
export const DEFAULT_DUPLICATE_LEAD_DAYS = 30
export const DEFAULT_DUPLICATE_CLICK_DAYS = 1

Duplicated.propTypes = propTypes;
Duplicated.defaultProps = {};
